import {
  DEFAULT_NA,
  PROFILE_SUBNAME,
  UPGRADE_VOUCHER_STEP,
} from '../newrelic-constants';

import {
  getEnvironmentMicro,
  getFfnAMR,
  getLastName,
  getLegEntity,
  getLegRegion,
  getOD,
  getPNR,
  getTierAMR,
  getTripType,
} from '../newrelic-helpers';

export function nrUpgradeVoucher(globalState, actionName, fullStory, metricData) {
  const {
    action,
  } = metricData;

  const {
    errorCode: errorAction,
    request: req,
    responseFromApi = {},
    step: stepAction,
    vouchersStatus,
  } = action;

  const {
    payload = {},
  } = req || {};

  const {
    cobrandCompanyName: cobrandNamme,
  } = payload;

  const {
    unredeemedVouchers = [],
    voucherRedeemed = [],
  } = vouchersStatus || {};

  const {
    resultState: result,
  } = metricData;

  const reservationCode = getPNR(globalState);
  const lastName = getLastName(globalState);
  const ffnAM = getFfnAMR();
  const ffn = ffnAM !== DEFAULT_NA ? String(ffnAM).padStart(11, '0') : ffnAM;
  const tierAMR = getTierAMR(globalState);
  const step = stepAction ?  UPGRADE_VOUCHER_STEP[stepAction] : DEFAULT_NA;
  const cobrandCompanyName = stepAction === 'POST' ? cobrandNamme : DEFAULT_NA;
  const legEntity = getLegEntity(globalState);
  const legRegion = getLegRegion(globalState);
  const route = getOD(globalState);
  const resultState = result || DEFAULT_NA;
  const responseHasUpgrades = Object.hasOwn(responseFromApi, 'upgrades');
  const request = (stepAction === 'POST' && (resultState === 'failure' || unredeemedVouchers?.length)) ? payload : DEFAULT_NA;
  const response = (stepAction === 'POST' && responseHasUpgrades && (unredeemedVouchers?.length || resultState === 'failure') ) ? responseFromApi : DEFAULT_NA;

  let tripType = '*';
  const tripT = getTripType(globalState);
  if (tripT === 'ONEWAY') {
    tripType = 'OW';
  } else if (tripT === 'ROUNDTRIP') {
    tripType = 'RT';
  } else if (tripT === 'MULTICITY') {
    tripType = 'MC';
  }

  const voucherCodeRedeemed = (stepAction === 'POST' && voucherRedeemed.length) ?  voucherRedeemed.map(up => up.voucherCode) : DEFAULT_NA;
  const voucherCodeFailed = (stepAction === 'POST' && unredeemedVouchers.length) ?  unredeemedVouchers.map(up => up.voucherCode) : DEFAULT_NA;
  const warning = (stepAction === 'POST' && unredeemedVouchers.length) ?  unredeemedVouchers.map(up => up.reason) : DEFAULT_NA;

  const errorCode = errorAction || DEFAULT_NA;

  const data = {
    actionSubname: PROFILE_SUBNAME.WEBUPGRADEVOUCHER,
    cobrandCompanyName,
    environment: getEnvironmentMicro(),
    errorCode,
    ffn,
    flow: 'MYB',
    fullstory: fullStory || '*',
    lastName,
    legEntity,
    legRegion,
    request,
    response,
    reservationCode,
    resultState,
    route,
    step,
    storefront: metricData?.storefront,
    subflow: 'ancillary',
    tierAMR,
    tripType,
    url: window.location.href,
    voucherCodeFailed,
    voucherCodeRedeemed,
    warning,
  };

  window.newrelic.addPageAction(actionName, data);
}